import { PiAsset } from "../Types/PiAsset";
import { addCard, removeCard } from "../Slices/DashboardSlice";
import { AppDispatch } from "../app/store";
import { Card } from "../CardFactory";

const findAssetCapability = (
    piAsset: PiAsset | undefined,
    assetName: string,
    capabilityName: string
): { guid: string, displayName: string } | null => {
    if (!piAsset || !piAsset.Children) return null;

    const searchAsset = (asset: PiAsset): { guid: string, displayName: string } | null => {
        if (asset.Name === assetName) {
            const capability = asset.Capabilities?.find((cap: any) => cap.Name === capabilityName);
            if (capability) {
                return {
                    guid: capability.Guid,
                    displayName: `${asset.WorkCenter} ${asset.Name} ${asset.Alias}`
                };
            }
        }

        if (asset.Children) {
            for (const child of asset.Children) {
                const result = searchAsset(child);
                if (result) return result;
            }
        }

        return null;
    };

    return searchAsset(piAsset);
};


const findFirstChildCapability = (
    piAsset: PiAsset | undefined,
    parentName: string,
    capabilityName: string
): { guid: string, displayName: string } | null => {
    if (!piAsset || !piAsset.Children) return null;

    const searchAsset = (asset: PiAsset): { guid: string, displayName: string } | null => {
        if (asset.Name === parentName && asset.Children && asset.Children.length > 0) {
            const firstChild = asset.Children[0];
            const capability = firstChild.Capabilities?.find((cap: any) => cap.Name === capabilityName);
            if (capability) {
                return {
                    guid: capability.Guid,
                    displayName: `${firstChild.WorkCenter} ${firstChild.Name} ${firstChild.Alias}`
                };
            }
        }

        if (asset.Children) {
            for (const child of asset.Children) {
                const result = searchAsset(child);
                if (result) return result;
            }
        }

        return null;
    };

    return searchAsset(piAsset);
};


export const createAssetTreeControls = (
    piAsset: PiAsset | undefined,
    dispatch: AppDispatch,
    cards: Card[]
) => {
    return {
        addTourCards: () => {
            const addedCards: { type: string; guid: string }[] = [];
            const oeeCard = findAssetCapability(piAsset, '103', 'oee');
            if (oeeCard) {
                const exists = cards.some(card => card.elementGuid === oeeCard.guid && card.type === 'oee');
                if (!exists) {
                    dispatch(addCard({
                        type: 'oee',
                        name: oeeCard.displayName,
                        elementGuid: oeeCard.guid
                    }));
                    addedCards.push({ type: 'oee', guid: oeeCard.guid });
                } else {
                    addedCards.push({ type: 'oee', guid: oeeCard.guid });
                }
            }

            const mstatusCard = findAssetCapability(piAsset, '1', 'mstatus');
            if (mstatusCard) {
                const exists = cards.some(card => card.elementGuid === mstatusCard.guid && card.type === 'mstatus');
                if (!exists) {
                    dispatch(addCard({
                        type: 'mstatus',
                        name: mstatusCard.displayName,
                        elementGuid: mstatusCard.guid
                    }));
                    addedCards.push({ type: 'mstatus', guid: mstatusCard.guid });
                } else {
                    addedCards.push({ type: 'mstatus', guid: mstatusCard.guid });
                }
            }


            const machineCard = findFirstChildCapability(piAsset, '1', 'machine');
            if (machineCard) {
                const exists = cards.some(card => card.elementGuid === machineCard.guid && card.type === 'machine');
                if (!exists) {
                    dispatch(addCard({
                        type: 'machine',
                        name: machineCard.displayName,
                        elementGuid: machineCard.guid
                    }));
                    addedCards.push({ type: 'machine', guid: machineCard.guid });
                } else {
                    addedCards.push({ type: 'machine', guid: machineCard.guid });
                }
            }

            return addedCards;
        },

        removeTourCards: () => {
            const machineCard = findFirstChildCapability(piAsset, '1', 'machine');
            if (machineCard) {
                dispatch(removeCard({ eguid: machineCard.guid, type: 'machine' }));
            }

            const mstatusCard = findAssetCapability(piAsset, '1', 'mstatus');
            if (mstatusCard) {
                dispatch(removeCard({ eguid: mstatusCard.guid, type: 'mstatus' }));
            }

            const oeeCard = findAssetCapability(piAsset, '103', 'oee');
            if (oeeCard) {
                dispatch(removeCard({ eguid: oeeCard.guid, type: 'oee' }));
            }
        }
    };
};
